import useSeo from "@/hooks/useSeo";
import { Award, Heart, ShieldCheck, Users } from "lucide-react";

const TECH_IMG = "https://images.pexels.com/photos/32588555/pexels-photo-32588555.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function About() {
  useSeo({
    title: "About | Full Indoor Air Services",
    description: "Locally owned indoor air quality company serving Maryland, Washington DC, and Virginia.",
    canonical: "https://capitalindoorair.com/about",
  });

  return (
    <div className="bg-bone" data-testid="about-page">
      <section className="section-pad">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-3">Our story</div>
            <h1 className="font-heading text-5xl md:text-6xl tracking-tighter font-light">
              We started with one belief: <span className="text-forest">your home should feel like fresh air.</span>
            </h1>
            <div className="mt-8 space-y-5 text-muted2 leading-relaxed text-lg">
              <p>
                Full Indoor Air Services is a locally owned company serving Maryland, Washington DC, and Virginia.
                We've cleaned the air in over 12,400 homes and businesses across the region since 2014.
              </p>
              <p>
                Most duct cleaning companies use scare tactics and bait pricing. We don't. We charge a flat, fair rate,
                show before-and-after photos for every job, and only recommend services your system actually needs.
              </p>
              <p>
                Our technicians are background-checked, uniformed, and trained on NADCA-aligned ACR cleaning standards.
                We treat your home like our own — drop cloths, shoe covers, and a full walkthrough before we leave.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden card-surface">
              <img src={TECH_IMG} alt="Our technician at work" className="w-full h-[520px] object-cover" />
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: Users, label: "Homes cleaned", value: "12,400+" },
            { icon: Award, label: "Avg. rating", value: "4.9 ★" },
            { icon: ShieldCheck, label: "Licensed & insured", value: "MD · DC · VA" },
            { icon: Heart, label: "Repeat clients", value: "62%" },
          ].map((s) => {
            const I = s.icon;
            return (
              <div key={s.label} className="card-surface p-6">
                <I size={20} className="text-forest" />
                <div className="font-heading text-3xl mt-3">{s.value}</div>
                <div className="eyebrow mt-2">{s.label}</div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
